var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.63 23.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c0c0c;}.cls-2{fill:#505050;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.81,
    cy: 11.81,
    r: 10.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.14,15.45l-5.33-.66-5.32.66a3,3,0,0,0-2.61,3v.87a10.87,10.87,0,0,0,15.87,0v-.87A3,3,0,0,0,17.14,15.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.78,9.83c0,2.74-1.77,5-4,5s-4-2.22-4-5a3.65,3.65,0,0,1,4-4A3.65,3.65,0,0,1,15.78,9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.81,15.7c-2.68,0-4.87-2.63-4.87-5.87A4.56,4.56,0,0,1,11.81,5a4.56,4.56,0,0,1,4.88,4.87C16.69,13.07,14.5,15.7,11.81,15.7Zm0-8.93A2.77,2.77,0,0,0,8.76,9.83c0,2.23,1.37,4.05,3.05,4.05s3.06-1.82,3.06-4.05A2.77,2.77,0,0,0,11.81,6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.81,23.63a11.69,11.69,0,0,1-8.59-3.72A.91.91,0,0,1,3,19.28v-.87a3.9,3.9,0,0,1,3.41-3.86l5.32-.66h.23l5.32.66h0a3.9,3.9,0,0,1,3.41,3.86v.87a.91.91,0,0,1-.25.63A11.7,11.7,0,0,1,11.81,23.63Zm-7-4.71a10,10,0,0,0,14.05,0v-.51A2.07,2.07,0,0,0,17,16.36l-5.22-.65-5.21.65a2.07,2.07,0,0,0-1.81,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.81,23.63A11.82,11.82,0,1,1,23.63,11.81,11.83,11.83,0,0,1,11.81,23.63Zm0-21.81a10,10,0,1,0,10,10A10,10,0,0,0,11.81,1.82Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.be15e0a41f60a163a585fb33766acfbf.svg";
export { ForwardRef as ReactComponent };